export default Object.freeze({
  TITLE: 'SMS 관리',
  TAB_ONE: 'SMS 발송',
  TAB_TWO: 'SMS 템플릿 설정',
  TAB_THREE: '자동SMS 설정',
  TAB_FOUR: '자동SMS 발송내역 조회',
  TAB_FIVE: '자동SMS 사용내역 조회',
  DETAIL_ONE: 'ⓘ 광고성/정보성 SMS를 발송할 수 있습니다.',
  DETAIL_TWO: 'Ⓘ 광고성 SMS 발송은 \'080 수신거부 번호\'가 등록되어 있어야 사용이 가능합니다.',
  DETAIL_FOUR_ONE: 'Ⓘ SMS 발송/사용내역은',
  DETAIL_FOUR_LINK: 'NHN Cloud',
  DETAIL_FOUR_TWO: '에서 확인할 수 있습니다.',
  TR_1: 'SMS유형',
  TR_2: '템플릿 설정',
  TR_2_ADD1: '발송 유형',
  TR_2_ADD2: '발신 번호',
  TR_3: '080 수신거부 번호',
  TR_4: '수신 대상 회원 선택',
  TR_5: '발송 설정',
  TR_6: '제목',
  TR_7: '내용',
  TR_8: '수신거부 문구',
  TEMPLATE_UNUSE: '사용 안 함',
  TEMPLATE_USE: '사용함',
  TEMPLATE_INUSE: '템플릿 선택',
  SENDTYPE_SMS: 'SMS (90byte)',
  SENDTYPE_LMS: 'LMS (2,000byte)',
  DETAIL_KIND: '발송 유형에 따라 SMS 발송 금액이 달라집니다.',
  DETAIL_TEL: '발신번호는 \'NHN Cloud > Notification > SMS > 발신번호관리\'에서 등록 및 관리가 가능합니다.',
  DETAIL_EMAIL: '080 수신거부 번호는 \'NHN Cloud > Notification > SMS > 080수신거부설정\' 에서 신청 및 관리가 가능합니다.',
  PLACEHOLDER_SENDNO: '발신번호를 등록해주세요.',
  PLACEHOLDER_EMAIL: '080 수신거부 번호를 신청해주세요.',
  RECIPIENT_ALL: '전체 회원',
  RECIPIENT_SELECT_MEMBER: '회원 선택',
  RECIPIENT_EXCEL: '엑셀 업로드',
  MEMBER_SELECT_BTN: '회원등급/그룹 선택',
  MEMBER_SEARCH_BTN: '회원 조회',
  EXCEL_DOWN_BTN: '엑셀양식 다운로드',
  EXCEL_UPLOAD_BTN: '엑셀 업로드',
  UPLOAD_FILE: '첨부파일',
  DESCRIPTION_1_1: '총',
  DESCRIPTION_1_2: '명',
  DESCRIPTION_1_3: '회원 선택 되었습니다. (중복 회원 제외)',
  DESCRIPTION_2: '광고성인 경우, 광고성 수신 미동의 회원은 발송 시 제외됩니다.',
  DESCRIPTION_3: '휴면회원 및 탈퇴회원은 수신 대상에서 제외됩니다.',
  DESCRIPTION_4: '예약발송인 경우 설정일과 발송일 수신 대상 회원이 일치하지 않을 수 있습니다.',
  DESCRIPTION_5: '광고성 메일의 경우, 수신자가 메일을 수신 거부 할 수 있는 기능이 메일 하단에 아래와 같이 추가 됩니다.',
  DESCRIPTION_6: '메일 수신을 원치 않으시면 [수신거부]를 클릭하세요.',
  DESCRIPTION_7: 'If you do not want to receive it, please click a [Unsubscription]',
  SENDIMM: '즉시 발송',
  SENDBACK: '예약 발송',
  SENDERNO_NULL: '발신번호를 등록해주세요.',
  TITLE_AD: '(광고)',
  CONTENT_AD: '[무료 수신거부]',
  TITLE_PLACEHOLDER: '제목을 입력해 주세요.',
  TITLE_PREVIEW: 'SMS 발송내용 미리보기',
  BTN_SAVE: '보내기',
  BTN_PREVIEW: '미리보기',
  BTN_RESET: '초기화',
  POPUP_TEMPLATE_SELECTOR: '템플릿 선택',
  POPUP_MEMBER_SELECT: '회원등급/그룹 선택 팝업',
  POPUP_MEMBER_SEARCH: '회원 조회 팝업',
  SUCCESS_SEND: '발송요청에 성공했습니다.',
  ERR_APP_KEY: '쇼핑몰 수정에서 SMS Appkey를 등록해 주셔야 발송이 가능합니다.',
  ERR_RECIPIENT_COUNT: '수신대상 회원을 선택해 주세요.',
  ERR_SENDTYPE: 'SMS 유형을 선택해주세요.',
  ERR_TEMPLATESENDTYPE_NULL: '템플릿을 선택해주세요.',
  ERR_TEMPLATESENDTYPE: '템플릿 발송 유형과 현재 발송유형이 같지 않습니다.',
  ERR_SENDERNO: '발신번호가 등록된 후 SMS를 발송할 수 있습니다.\NHN Cloud에서 발신번호를 등록해주세요.',
  ERR_TIME: '예약발송일시를 현재 기준 10분 이후로 설정해 주세요',
  ERR_TITLE: '제목을 입력해 주세요.',
  ERR_SUMMERNOTE: '내용을 입력해 주세요.',
  ERR_AD_SUMMERNOTE: '(광고)\n내용을 입력해 주세요.\n[무료 수신거부]{0}',
  ERR_EXCELTYPE: '파일 양식이 올바르지 않습니다. 파일 확인 후 첨부해 주세요.',
  ERR_EXCEL: '엑셀 양식이 올바르지 않습니다. 파일 확인 후 첨부해 주세요.',
  ERR_SMSBLOCKNO: '광고성 SMS는 080 수신거부 번호가 등록되어 있어야 발송할 수 있습니다.\NHN Cloud에서 080 수신거부 번호를 등록해주세요.',
  ERR_APPKEY: '정보성/광고성 SMS를 모두 발송할수 없습니다. 앱키를 등록해주세요.',
  ERR_SENDNO: '발신번호를 등록해주세요.',
  ERR_BLOCKER: '080 수신거부 번호 등록이 필요합니다.',
  SELECT_SEND_INFO_TYPE: [{'key': '', 'value': 'SMS유형을 선택해주세요'},
  {'key': 'INFORMATION', 'value': '정보성'},
  {'key': 'AD', 'value': '광고성'}],
  WARNING_MSG_NOT_MEMBER1: '비회원의 경우 광고성 수신 동의여부 확인이 불가하므로, 비회원 포함하여 발송 시 광고성 알림을 발송하지 않도록 유의하여 주십시오.',
  WARNING_MSG_NOT_MEMBER2: '사전에 개인정보 수집동의 또는 광고성 수신동의를 받지 않아 발생하는 불이익에 대하여 당사는 책임을 지지 않습니다.'

});
